import { IOrcamento } from "app/types/IOrcamento"
import { IProduto } from "app/types/produto/IProduto"
import * as R from 'ramda'

const produtoPodeSerAdicionadoAutomaticamenteAoOrcamento = (produto: IProduto, orcamento: IOrcamento, podeAdicionarProdutoRepetido: boolean = false, podeAdicionarProdutoAgregado: boolean = false): {
    podeSerAdicionado: boolean,
    mensagensValidacao: string[]
} => {

    const podeSerAdicionado =
        (produto.TipoComponente != "P") &&
        (!produto.BaseTintometricoSimplificado) &&
        (podeAdicionarProdutoRepetido ? true : produto.Repetido == false) &&
        (podeAdicionarProdutoAgregado ? true : produto.TemProdutoAgregado == false) &&
        (podeAdicionarProdutoAgregado ? true : produto.TemProdutoAgregadoSugerido == false) &&
        (orcamento?.preVendas || []).length == 0

    return {
        podeSerAdicionado,
        mensagensValidacao: R.pipe(
            R.append(produto.BaseTintometricoSimplificado || produto.TipoComponente == "P" ? "Produtos do Sistema Tintométrico não podem ser adicionados automaticamente. </br>Por favor, utilize a pesquisa padrão de produtos" : undefined),
            R.append(podeSerAdicionado && produto.Repetido === true && produto.AcaoProdutoRepetido == 1 ? "Atenção: </br>Produto já existente no pedido. </br></br>Quantidade foi incrementada" : undefined),
            R.append(podeSerAdicionado && produto.Repetido === true && produto.AcaoProdutoRepetido != 1 ? "Atenção! Produto já existente no pedido. </br>Um novo produto de mesmo código foi adicionado ao orçamento" : undefined),
            R.append(podeSerAdicionado && produto.TemProdutoAgregado == true ? "O produto adicionado possui agregados. </br>Para mais detalhes, utilize a pesquisa padrão de produtos" : undefined),
            R.append(podeSerAdicionado && produto.TemProdutoAgregadoSugerido == true ? "O produto adicionado possui agregados sugeridos. </br>Para mais detalhes, utilize a pesquisa padrão de produtos" : undefined),
            //R.append((orcamento?.preVendas || []).length == 0 ? "Não possui pre-vendas" : undefined),
            R.append(produto.PossuiSimilares ? "O produto adicionado possui similares. Para mais detalhes, utilize a pesquisa padrão de produtos" : undefined),
            R.filter(m => m != undefined)

        )([])

    }
}

export default produtoPodeSerAdicionadoAutomaticamenteAoOrcamento